import {
    InternetAndMobileOffersResponseSuccess,
    InternetAndMobileOffersFunctionalErrorResponse,
    InternetAndMobileOffersTechnicalErrorResponse
} from "../models/InternetAndMobileApiResponse";

declare const $: any;

export class InternetAndMobileService {
    private static readonly API_URLS = {
        INTERNET_MOBILE: '/api/internet-mobile'
    };

    /**
     * Récupère les combos d'offres Internet et Mobile et les mentions légales associées
     */
    static getOffers(): Promise<InternetAndMobileOffersResponseSuccess> {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: this.API_URLS.INTERNET_MOBILE,
                method: "GET",
                xhrFields: {withCredentials: true},
                crossDomain: true,
                contentType: "application/json",
                success: (response: InternetAndMobileOffersResponseSuccess) => {
                    resolve(response);
                },
                error: (xhr: any) => {
                    this.handleApiError(xhr, reject);
                }
            });
        });
    }

    /**
     * Gère les erreurs des appels API et effectue une redirection si nécessaire
     */
    private static handleApiError(xhr: any, reject: (reason?: any) => void): void {
        const errorData =
                (xhr.responseJSON as InternetAndMobileOffersTechnicalErrorResponse | InternetAndMobileOffersFunctionalErrorResponse) || null;

        if (errorData?.redirectUrl) {
            window.location.href = errorData.redirectUrl;
            reject({redirecting: true});
        } else {
            reject({
                status: xhr.status
            });
        }
    }
}
